import { PartieFormulaireInterface } from './Exa_PartieFormulaire'

export enum TypeInput {
    TYPE_CHECK_BOX = 1,
    TYPE_DATE = 2,
    TYPE_DATE_TIME = 3,
    TYPE_TIME = 4,
    TYPE_FILE = 5,
    TYPE_RADIO = 6,
    TYPE_SELECT = 7,
    TYPE_TEXT = 8,
    TYPE_TEXT_AREA = 9,
    TYPE_PHONE_NUMBER = 10,
    TYPE_NUM_SECU = 11,
    TYPE_NUMBER = 12,
    TYPE_TEXT_INFO = 13,
    TYPE_CHOIX_MULTIPLE = 14,
    TYPE_EMAIL = 15
}

interface TypeInputSpec {
    index: number;
    libelle: string;
}

export function getTypeInputSpec(typeInput: TypeInput): TypeInputSpec {
    switch (typeInput) {
        case TypeInput.TYPE_CHECK_BOX:
            return { index: 1, libelle: 'Case à cocher' }
        case TypeInput.TYPE_DATE:
            return { index: 2, libelle: 'Champs Date' }
        case TypeInput.TYPE_DATE_TIME:
            return { index: 3, libelle: 'Champs Date et heure' }
        case TypeInput.TYPE_TIME:
            return { index: 4, libelle: 'Champs heure' }
        case TypeInput.TYPE_FILE:
            return { index: 5, libelle: 'Envoi de fichier' }
        case TypeInput.TYPE_RADIO:
            return { index: 6, libelle: 'Choix unique' }
        case TypeInput.TYPE_SELECT:
            return { index: 7, libelle: 'Menu déroulant' }
        case TypeInput.TYPE_TEXT:
            return { index: 8, libelle: 'Texte court' }
        case TypeInput.TYPE_TEXT_AREA:
            return { index: 9, libelle: 'Texte long' }
        case TypeInput.TYPE_PHONE_NUMBER:
            return { index: 10, libelle: 'Numéro de téléphone' }
        case TypeInput.TYPE_NUM_SECU:
            return { index: 11, libelle: 'Numéro de sécurité social' }
        case TypeInput.TYPE_NUMBER:
            return { index: 12, libelle: 'Nombre ou chiffre' }
        case TypeInput.TYPE_TEXT_INFO:
            return { index: 13, libelle: 'Texte informatif' }
        case TypeInput.TYPE_CHOIX_MULTIPLE:
            return { index: 14, libelle: 'Choix multiple' }
        case TypeInput.TYPE_EMAIL:
            return { index: 15, libelle: 'Adresse e-mail' }

        default:
            return { index: 6, libelle: 'Texte court' }
    }
}

export interface InputInterface {
    id: number | 0;
    ref: string;
    libelle: string;
    type: TypeInput;
    ordre: number | 0;
    requis: boolean | false;
    data: any | null;
    condition: any | null;
    value: any | null;
    description: string;
    anomalie?: string | null;
}
